export const sx = {
    box: {
        width: "95vw",
        height: "calc(95vh - 38px)",
        position: 'relative',
        maxHeight: {
            xs: 'calc(95vh - 38px)'
        },
        border: "1px solid rgb(187, 187, 187)",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent:'flex-end',
        maxWidth: "100%",
        overflowY: "auto",
        minWidth: {
            xs: '95%',
            sm: '400px'
        },
        '.lightTheme&':{
            backgroundColor: 'rgba(230, 230, 230, 1)',
        },

        padding: {
            xs: '0 7px',
            lg: '0'
        }
    },

    inner: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    },
    btn: {
        position: 'absolute',
        right: '10px',
        top: '10px',
        zIndex: 666666666666666,
    },
    content: {width: "100%", height: "100%"},
    overflowHidden: {overflow: "hidden"},
    title: {
        fontWeight: "500",
        display: "flex",
        justifyContent: "flex-start",
        columnGap: "10px",
        alignItems: "center",
        whiteSpace: "nowrap",
        maxWidth: {
            xs: "calc(100% - 35px",
            lg: "calc(100% - 70px)",
        },
        overflowY: "auto",
        paddingLeft: "10px",
    },
    action: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        position: "sticky",
        top: "0",
        width: "100%",
        zIndex: 5,
    },
}
